<template>
    <div v-title :data-title="title" >
        <div class="index-banner">
            <img src="@/assets/images/banner.jpg" class="full-width full-height"/>
            <div class="index-banner-box flex flex-row">
                <div class="half-width flex flex-col">
                    <div style="margin-top: 80px; margin-left: 200px; font-size: 28px;">量子文档</div>
                    <div style="margin-top: 20px; margin-left: 200px; font-size: 18px;" >极简在线文档处理工具，一键分享、文档分身，多人编辑生成各自版本</div>
                    <div style="margin-top: 10px; margin-left: 200px; font-size: 18px;" >电脑端 + 小程序端同步使用，不受空间限制，随时随地分享</div>
                    <div style="margin-top: 10px; margin-left: 200px; font-size: 18px;" >写测试文档，做调查问卷，制作试卷，记录错题，写日记，记便签，处理待办等</div>
                    <div style="margin-top: 10px; margin-left: 200px; font-size: 18px;" >点赞、评论、互动，让文档建立起沟通桥梁</div>
                </div>
                <div class="half-width flex flex-center-sp flex-center-cz">
                    <img src="@/assets/images/banner-img.png" style="width: 350px; height: 400px;" />
                </div>
            </div>
        </div>
        <div class="flex flex-center-sp flex-center-cz margin-top-xxl font-xxl font-bold ">适用于多种场景</div>
        <div class="flex flex-center-sp">
            <div class="flex margin-top-xxl flex-space-evenly" style="width: 1280px">
                <div  class="index-scene-box border-radius-s flex flex-col  padding-xl">
                    <div class="flex flex-center-sp">
                        <img src="@/assets/images/shangke.png" style="width: 150px; height: 150px;" class="margin-top-xl" />
                    </div>
                    
                    <div class="flex flex-center-sp flex-center-cz margin-top-xl font-xl font-bold ">教师</div>
                    <div style="margin-top: 20px; font-size: 14px;" class="color-rgb-05">整理学习资料、分享学习要点</div>
                    <div style="margin-top: 5px; font-size: 14px;" class="color-rgb-05">制作试卷、分享考卷、考试结果统计及时统计、错题分析</div>
                    <div style="margin-top: 5px; font-size: 14px;" class="color-rgb-05">分类归纳、随时分享，高效家校沟通</div>
                </div>

                <div  class="index-scene-box border-radius-s flex flex-col  padding-xl">
                    <div class="flex flex-center-sp">
                        <img src="@/assets/images/student.png" style="width: 180px; height: 150px;" class="margin-top-xl" />
                    </div>
                    
                    <div class="flex flex-center-sp flex-center-cz margin-top-xl font-xl font-bold ">学生</div>
                    <div style="margin-top: 20px;  font-size: 14px;" class="color-rgb-05">记录学习笔记，随时复习</div>
                    <div style="margin-top: 5px;  font-size: 14px;" class="color-rgb-05">记录错题，错题反复练习</div>
                    <div style="margin-top: 5px;  font-size: 14px;" class="color-rgb-05">参加考试，考完直接查看分数及排名</div>
                </div>


                <div class="index-scene-box border-radius-s flex flex-col  padding-xl">
                    <div class="flex flex-center-sp">
                        <img src="@/assets/images/coder.png" style="width: 150px; height: 150px;" class="margin-top-xl" />
                    </div>
                    <div class="flex flex-center-sp flex-center-cz margin-top-xl font-xl font-bold ">程序员</div>
                    <div style="margin-top: 20px; font-size: 14px;" class="color-rgb-05">分享API文档，需求文档、设计文档、测试文档等</div>
                    <div style="margin-top: 5px;  font-size: 14px;" class="color-rgb-05">评论后还可形成沟通痕迹、参与人员方便了解项目进展情况</div>
                </div>


                <div class="index-scene-box border-radius-s flex flex-col padding-xl">
                    <div class="flex flex-center-sp">
                        <img src="@/assets/images/office.png" style="width: 150px; height: 150px;" class="margin-top-xl" />
                    </div>
                    
                    <div class="flex flex-center-sp flex-center-cz margin-top-xl font-xl font-bold ">其他</div>
                    <div style="margin-top: 20px;  font-size: 14px;" class="color-rgb-05">只要是要分享以上文档给ta</div>
                    <div style="margin-top: 5px;  font-size: 14px;" class="color-rgb-05">不管您是什么职业，其实均适用</div>

                </div>

            </div>
        </div>
        
        <div class="flex flex-center-sp flex-center-cz margin-top-xxl font-xxl font-bold ">示例文档</div>
        <div class="flex flex-center-sp">
            <div class="flex margin-top-xl flex-space-evenly" style="width: 1000px">
                <div class="index-file-box flex flex-col flex-center-cz pointer" @click="showDocA('doc?id=1883849782052528129')">
                    <div class="flex flex-center-sp">
                        <img src="@/assets/images/drwd.png"  class="margin-top-xl logo-48" />
                    </div>
                    <div class="margin-top-l flex-center-sp">多人编辑文档</div>
                </div>
                <div class="index-file-box flex flex-col flex-center-cz pointer" @click="showDocA('doc?id=1883505966128902145')" >
                    <div class="flex flex-center-sp">
                        <img src="@/assets/images/cswd.png"  class="margin-top-xl logo-48" />
                    </div>
                    <div class="margin-top-l flex-center-sp">测试文档</div>                    
                </div>
                <div class="index-file-box flex flex-col flex-center-cz pointer" @click="showDocA('doc?id=1883531331862155266')">
                    <div class="flex flex-center-sp">
                        <img src="@/assets/images/sjwd.png"  class="margin-top-xl logo-48" />
                    </div>
                    <div class="margin-top-l flex-center-sp" >试卷</div>                       
                </div>
                <div class="index-file-box flex flex-col flex-center-cz pointer"  @click="showDoc('doc?shareId=1883528517051822082')">
                    <div class="flex flex-center-sp">
                        <img src="@/assets/images/rjwd.png"  class="margin-top-xl logo-48" />
                    </div>
                    <div class="margin-top-l flex-center-sp ">日记</div>                     
                </div>

            </div>

        </div>

        <ScanLogin  :show="showScanLogin" @close="showScanLogin = false" @confirm="loginConfirm"></ScanLogin>

    </div>

</template>

<script>
 import ScanLogin from '@/modules/scanLogin/ScanLogin.vue'
 import { objToStr } from '../utils/sysUtils';
 
 export default {
    name:'Home',
    components:{ScanLogin},
    data() {
        return {
            title: '北京安宇润德科技有限公司 - 量子文档 - 极简文档分享工具',
            url:"",
            showScanLogin: false
        }
    },
    methods:{
      showDoc(url) {
        this.$router.push({
            path: '/' + url,
        }) 
      },
      showDocA(url) {
        let userId = sessionStorage.getItem("userId");
        if (userId == null || userId == "" || userId == "null") {
            this.url = url,
            this.showScanLogin = true;
            return false;                 
        } 
        this.$router.push({
            path: '/' + url,
        }) 
      },
      loginConfirm() {
        this.token = sessionStorage.getItem("token");
         if (objToStr(this.token) != "") {
            this.userId = sessionStorage.getItem("userId");
         } 
         this.$router.push({
            path: '/' + this.url
         }) 
         this.showScanLogin = false
      }
    }
 }
    

</script>

<style scoped>

.index-body {
    margin-top: 60px;
    width: 100%;
}
.index-banner{
    margin-top: 60px;
    width: 100%;
    height: 460px;
    position: relative;
}
.index-banner-box {
    position: absolute;
    left: 0;
    right: 0;
    top:0;
}
.index-scene-box {
    width: 250px;
    background-color: #f2f8ff;
}

.index-file-box {
    width: 200px;
}




</style>


// WEBPACK FOOTER //
// src/views/Home.vue